var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { NativeModule } from "./NativeModule";
import { NativeInterface } from "./NativeInterface";
import { Native } from "../native";
var DisplaysNative = /** @class */ (function (_super) {
    __extends(DisplaysNative, _super);
    function DisplaysNative(currentScreenId) {
        if (currentScreenId === void 0) { currentScreenId = null; }
        var _this = _super.call(this) || this;
        _this.messageListener = null;
        if (currentScreenId === null) {
            var context = Native.getContext();
            _this.currentScreenId = context.screenId;
        }
        else
            _this.currentScreenId = currentScreenId;
        NativeInterface.instance.addModule(_this);
        return _this;
    }
    DisplaysNative.prototype.getPrefix = function () {
        return 'displays_';
    };
    /**
     * Get current connected displays
     */
    DisplaysNative.prototype.status = function () {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'status',
            params: {}
        }).then(function (rawData) {
            return rawData;
        });
    };
    DisplaysNative.prototype.enable = function (id, url) {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'enable',
            params: {
                screenId: '' + id,
                url: url
            }
        }).then(function (rawData) {
        });
    };
    DisplaysNative.prototype.disable = function (id) {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'disable',
            params: {
                screenId: '' + id,
            }
        }).then(function (rawData) {
        });
    };
    DisplaysNative.prototype.listenMessages = function (listener, registerAsScreenId) {
        var _this = this;
        if (registerAsScreenId === void 0) { registerAsScreenId = null; }
        if (registerAsScreenId === null) {
            registerAsScreenId = Native.getContext().screenId;
        }
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'listen',
            params: {
                screenId: '' + registerAsScreenId,
            }
        }).then(function () {
            _this.messageListener = listener;
        });
    };
    DisplaysNative.prototype.sendMessage = function (destinationScreenId, message) {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'sendMessage',
            params: {
                dstScreenId: '' + destinationScreenId,
                srcScreenId: '' + this.currentScreenId,
                message: message,
            }
        });
    };
    DisplaysNative.prototype.onEvent = function (event) {
        if (event.name === this.getPrefix() + 'message') {
            if (this.messageListener)
                this.messageListener(event.params.srcScreenId, event.params.message);
        }
    };
    return DisplaysNative;
}(NativeModule));
export { DisplaysNative };
//# sourceMappingURL=DisplaysNative.js.map